import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const SikSorulanSorular = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('sikSorulanSorular.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <h3 className="academy-subtitle">{t('sikSorulanSorular.subtitle')}</h3>
                        <p className="academy-intro-text">{t('sikSorulanSorular.intro.p1')}</p>
                        
                        <div className="academy-type-card mt-4">
                            <h5>{t('sikSorulanSorular.intro.categoriesTitle')}</h5>
                            <ul className="mb-0">
                                {t('sikSorulanSorular.intro.categories', { returnObjects: true }).map((category, index) => (
                                    <li key={index}>{category}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Kategoriler */}
                {t('sikSorulanSorular.categories', { returnObjects: true }).map((category, catIndex) => (
                    <div className={`academy-section mt-5 mb-5`} key={catIndex}>
                        <div className="container">
                            <h2 className="academy-section-title">{category.category}</h2>
                            
                            {category.questions.map((qa, qaIndex) => (
                                <div className="academy-highlight-box mb-4" key={qaIndex}>
                                    <h5 className="text-primary mb-3">{qa.question}</h5>
                                    <div dangerouslySetInnerHTML={{ __html: qa.answer }} />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                {/* Hala Sorunuz mu Var? */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('sikSorulanSorular.stillQuestions.title')}</h2>
                        <p className="academy-section-text">{t('sikSorulanSorular.stillQuestions.intro')}</p>
                        
                        <div className="row g-4">
                            {t('sikSorulanSorular.stillQuestions.channels', { returnObjects: true }).map((channel, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-type-card">
                                        <h5>{channel.name}</h5>
                                        <p className="mb-0">{channel.details}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="academy-highlight-box text-white mt-4">
                            <h6 className="text-white">{t('sikSorulanSorular.stillQuestions.tip.title')}</h6>
                            <p className="mb-0">{t('sikSorulanSorular.stillQuestions.tip.text')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Cta1 
            title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}/>
        </div>
    );
};

export default SikSorulanSorular;
